import {
	ADD_ANAGRAFICHE_CSV_FAIL,
	ADD_ANAGRAFICHE_CSV_START,
	ADD_ANAGRAFICHE_CSV_SUCCESS,
	ADD_CSV_FAIL,
	ADD_CSV_START,
	ADD_CSV_SUCCESS,
	ADD_POSITIVI_CSV_FAIL,
	ADD_POSITIVI_CSV_START,
	ADD_POSITIVI_CSV_SUCCESS,
	ADD_TAMPONI_CSV_FAIL,
	ADD_TAMPONI_CSV_START,
	ADD_TAMPONI_CSV_SUCCESS,
	CHECK_UPLOAD_FAIL,
	CHECK_UPLOAD_START,
	CHECK_UPLOAD_SUCCESS, SEND_CSV_FAIL,
	SEND_CSV_START, SEND_CSV_SUCCESS
} from "./actions/ActionTypes";

export const initCsvState = () => {
	return {
		loadingAddCsv: true,
		errorAddCsv: "",
		loadingAddTamponi: true,
		errorAddTamponi: "",
		loadingAddAnagrafiche: true,
		errorAddAnagrafiche: "",

		loadingCheckStatus: true,
		errorCheckStatus: "",
		status: {},

		idUpload: "",

		loadingSendSmsEmail: true,
		errorSendSmsEmail: "",
	}
}

export const CSV_INITIAL_STATE = {}

export const CsvReducer = (state = CSV_INITIAL_STATE, action) => {
	switch (action.type) {
		case ADD_POSITIVI_CSV_START:
			return {
				...state,
				loadingAddCsv: true,
				errorAddCsv: "",
			}
		case ADD_POSITIVI_CSV_SUCCESS:
			return {
				...state,
				loadingAddCsv: false,
				errorAddCsv: "",
			}
		case ADD_POSITIVI_CSV_FAIL:
			return {
				...state,
				loadingAddCsv: false,
				errorAddCsv: action.error,
			}
		case ADD_TAMPONI_CSV_START:
			return {
				...state,
				loadingAddTamponi: true,
				errorAddTamponi: "",
			}
		case ADD_TAMPONI_CSV_SUCCESS:
			return {
				...state,
				loadingAddTamponi: false,
				errorAddTamponi: "",
				idUpload: action.payload
			}
		case ADD_TAMPONI_CSV_FAIL:
			return {
				...state,
				loadingAddTamponi: false,
				errorAddTamponi: action.error,
			}
		case ADD_ANAGRAFICHE_CSV_START:
			return {
				...state,
				loadingAddAnagrafiche: true,
				errorAddAnagrafiche: "",
			}
		case ADD_ANAGRAFICHE_CSV_SUCCESS:
			return {
				...state,
				loadingAddAnagrafiche: false,
				errorAddAnagrafiche: "",
			}
		case ADD_ANAGRAFICHE_CSV_FAIL:
			return {
				...state,
				loadingAddAnagrafiche: false,
				errorAddAnagrafiche: action.error,
			}
		case ADD_CSV_START:
			return {
				...state,
				loadingAddCsv: true,
				errorAddCsv: "",
			}
		case ADD_CSV_SUCCESS:
			return {
				...state,
				loadingAddCsv: false,
				errorAddCsv: "",
			}
		case ADD_CSV_FAIL:
			return {
				...state,
				loadingAddCsv: false,
				errorAddCsv: action.error,
			}
		case CHECK_UPLOAD_START:
			return {
				...state,
				loadingCheckStatus: true,
				errorCheckStatus: "",
			}
		case CHECK_UPLOAD_SUCCESS:
			return {
				...state,
				loadingCheckStatus: false,
				errorCheckStatus: "",
				status: action.payload
			}
		case CHECK_UPLOAD_FAIL:
			return {
				...state,
				loadingCheckStatus: false,
				errorCheckStatus: action.error,
			}
		case SEND_CSV_START:
			return {
				...state,
				loadingSendSmsEmail: true,
				errorSendSmsEmail: "",
			}
		case SEND_CSV_SUCCESS:
			return {
				...state,
				loadingSendSmsEmail: false,
				errorSendSmsEmail: "",
			}
		case SEND_CSV_FAIL:
			return {
				...state,
				loadingSendSmsEmail: false,
				errorSendSmsEmail: action.error,
			}

		default:
			return state;
	}
}
